import firebase from "firebase"

export const getUserProfilePic = async (uid: string): Promise<string> => {
    return firebase
        .storage()
        .ref(`profiles/${uid}`)
        .getDownloadURL()
        .catch(() => {
            return "";
        });
};
